export default "__VITE_ASSET__B6C3GLYA__"